import { createContext, useEffect, useState } from "react";
import { Routes } from "@features/Routes";
import { ConnectedModal } from "@features/summary/ConnectedModal";
import { useKeycloak } from "./hooks/useKeycloak";
import { AppFooter } from "./AppFooter";
import "./stylesheets/index.scss";
import { clearStorage, getProspectReference } from "@utils/storage";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { Header } from "@features/header/Header";
interface INumberOfferContext {
    cartItemsNumber: number;
    setNumberOfferSelected(numberOfferSelected: number): void;
}

export const NumberOfferContext = createContext({} as INumberOfferContext);

export const App = () => {
    const [numberOfferSelected, setNumberOfferSelected] = useState(0);
    const {
        globalLoading,
        globalError,
        linkProspectIfConnected,
        displayChangedInfoModal,
        setDisplayChangedInfoModal,
    } = useKeycloak();
    const prospectReference = getProspectReference();

    useEffect(() => {
        if (!prospectReference) {
            setNumberOfferSelected(0);
        }
    }, [prospectReference]);

    return (
        <div id="app-container">
            <HandleErrorAndLoading error={globalError} isLoading={globalLoading} retryFetch={linkProspectIfConnected}>
                <NumberOfferContext.Provider value={{ cartItemsNumber: numberOfferSelected, setNumberOfferSelected }}>
                    <Header cartItemsNumber={numberOfferSelected} logoutCallback={clearStorage} />
                    <section id="container">
                        <ConnectedModal
                            isModalOpen={displayChangedInfoModal}
                            setModalOpen={setDisplayChangedInfoModal}
                        />
                        <Routes />
                    </section>
                    <AppFooter />
                </NumberOfferContext.Provider>
            </HandleErrorAndLoading>
        </div>
    );
};
